import React from "react";
import { NavLink } from "react-router-dom";

const ParentSiteList = ({ list, onUpdate }) => {
    return (
        <>
            <div className="table-responsive">
                <table className="table table-hover table-bordered">
                    <thead>
                        <tr className="text-left">
                            <th className="text-center">sn</th>
                            <th>Name </th>
                            <th>Email </th>
                            <th>Tel-Number</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list &&
                            list.map((p, index) => (
                                <tr key={p.id} className="odd gradeX text-left">
                                    <td className="text-center">
                                        <strong>{index + 1}</strong>
                                    </td>

                                    <td>
                                        <h4>{p.name}</h4>
                                    </td>

                                    <td>{p.email}</td>
                                    <td>{p.tel_number}</td>

                                    <td className="text-center">
                                        <button title="Update" className="btn btn-tbl-edit btn-xs text-success" onClick={() => onUpdate(p)}>
                                            <i className="fa fa-pencil"></i>
                                        </button>
                                        <NavLink
                                            title="Site"
                                            className="btn btn-tbl-edit btn-xs text-blue"
                                            to={{
                                                pathname: "./Site",
                                                search: `?ref=${p.id}`,
                                            }}
                                        >
                                            <i className="fa fa-home"></i>
                                        </NavLink>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};
export default ParentSiteList;
